import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import AttachmentsCard from 'components/molecules/card/attachments/AttachmentsCard';
import { DropzoneInputProps } from 'react-dropzone/.';
import { useTranslation } from 'react-i18next';
import { PiPaperclip, PiPaperPlaneTiltFill } from 'react-icons/pi';
import { IChatMessageAttachment } from 'services/chat/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './MessageForm.scss';

interface IMessageFormProps {
  attachments: File[];
  inputProps: DropzoneInputProps;
  openFiles?: () => void;
  customRef: React.LegacyRef<HTMLDivElement>;
  onRemoveAttachment?: (
    attachment: IChatMessageAttachment,
    index: number
  ) => void;
  onSendMessage: () => void;
  sendDisabled?: boolean;
  isPending?: boolean;
}

const MessageForm = ({
  attachments,
  inputProps,
  openFiles,
  customRef,
  onRemoveAttachment,
  onSendMessage,
  isPending,
  sendDisabled,
}: IMessageFormProps) => {
  const { t } = useTranslation();
  return (
    <div ref={customRef} className='message-form'>
      {!!attachments.length && (
        <div className='message-form-attachemnts'>
          {attachments.map((a, key) => (
            <AttachmentsCard
              key={key}
              attachment={{
                id: `${key}`,
                fileName: a.name,
                path: URL.createObjectURL(a),
                sizeInMB: a.size / (1024 * 1024),
                createdAt: '',
                extension: a.name.split('.')[a.name.split('.').length - 1],
                mD5Hash: '',
              }}
              onRemove={a => onRemoveAttachment && onRemoveAttachment(a, key)}
            />
          ))}
        </div>
      )}
      <div className='message-form-inputs'>
        <FormInput.Editor
          name='message'
          // appBackground
          borderless
          fullWidth
          placeholder={t('support.placeholder')}
          disabled={isPending}
          editorOptions={{editorProps: {}}}
        />
        <input {...inputProps} />
        <Button onlyIcon isClear onClick={openFiles} disabled={isPending}>
          <Button.Icon icon={<PiPaperclip />} />
        </Button>
        <Button
          onlyIcon
          variant={BUTTON_VARIANT.submit}
          isLoading={isPending}
          disabled={sendDisabled}
          onClick={onSendMessage}>
          <Button.Icon icon={<PiPaperPlaneTiltFill />} />
        </Button>
      </div>
    </div>
  );
};

export default MessageForm;
